import React, { Component } from 'react';
import Icon from '../../artzu-ui/src/Icon';
import CalendarHeader from '../../artzu-ui/src/Calendar/CalendarHeader';
import { m } from '../../utils';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';

class ListOfBookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null
    };
  }

  render() {
    const {
      currentMonth,
      nextMonth,
      prevMonth,
      monthStart,
      monthEnd,
      formatShift,
      selectBooking
    } = this.props;
    const { selected } = this.state;
    return (
      <Query
        query={gql`
          query getBookingList(
            $monthStart: DateTime!
            $monthEnd: DateTime!
          ) {
            currentUserBookings(
              startTime: $monthStart
              endTime: $monthEnd
            ) {
              id
              stringIdentifier
              startTime
              endTime
              vehicleClass
              parkinglot {
                id
                city
                region
                accessCode
                address {
                  id
                  city
                  postalCode
                  province
                  streetAddress
                }
              }
              duration
              earnings
              car {
                id
                plate
                parkingSpot
                lockboxCode
              }
            }
          }
        `}
        variables={{ monthStart, monthEnd }}>
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          // console.log(data.currentUserBookings.sort((a, b) => {
          //   return m(a.startTime).isAfter(m(b.startTime));
          // }))
          const bookings = data.currentUserBookings;
          return (
            <div className="my-bookings-list">
              <CalendarHeader
                nextMonth={nextMonth}
                prevMonth={prevMonth}
                currentMonth={currentMonth}
              />
              <div className="shift-list">
                {bookings.map((booking, index, array) => {
                  return (
                    <div
                      className={
                        index === array.length - 1
                          ? 'booking-row'
                          : 'booking-row bottom-border'
                      }
                      key={index}>
                      <a
                        href="javascript:void(0)"
                        onClick={() => {
                          selectBooking(booking);
                          this.setState({ selected: index });
                        }}
                        style={
                          selected === index ? { color: '#128DFF' } : {}
                        }>
                        <div className="booking-time">
                          <div>
                            <b>{m(booking.startTime).format('dddd')},</b>
                          </div>
                          <strong>
                            {m(booking.startTime).format('MMM Do, YYYY')}
                          </strong>
                          <p>
                            {formatShift(m(booking.startTime).hour())} to{' '}
                            {formatShift(m(booking.endTime).hour())}
                          </p>
                        </div>
                        <div className="booking-tier">
                          <strong>{booking.parkinglot.region[0].toUpperCase() + booking.parkinglot.region.slice(1)}</strong>
                          <p>{booking.vehicleClass.toUpperCase()}</p>
                        </div>
                        <div className="booking-arrow">
                          <Icon
                            name="ChevronRight"
                            size="xs"
                            color={selected === index ? '#128DFF' : '#000'}
                          />
                        </div>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default ListOfBookings;



// WEBPACK FOOTER //
// ./src/components/MyBookings/ListOfBookings.js